/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum ObservacaoTransfTitularidadeAliases {
  FETCH_CONSULTA = 'fetch-consulta',
  FIELD_OBSERVACAO = 'field-observacao',
  FORM_OBSERVACAO = 'form-observacao',
  INPUT_1 = 'input-1',
  PANEL_0 = 'panel-0',
}
export { ObservacaoTransfTitularidadeAliases };
